module.exports = __webpack_public_path__ + "static/pythonPillar-eff84372bda6015a043da78a3b036a76.svg";